"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stockpilePosReducer = exports.stockpilePosAction = exports.stockpilePosTypes = void 0;
const stockpile_pos_action_1 = __importDefault(require("./stockpile-pos.action"));
exports.stockpilePosAction = stockpile_pos_action_1.default;
const stockpile_pos_reducer_1 = __importDefault(require("./stockpile-pos.reducer"));
exports.stockpilePosReducer = stockpile_pos_reducer_1.default;
const stockpile_pos_sub_component_1 = __importDefault(require("./sub-components/stockpile-pos.sub-component"));
const stockpile_pos_types_1 = require("./stockpile-pos.types");
Object.defineProperty(exports, "stockpilePosTypes", { enumerable: true, get: function () { return stockpile_pos_types_1.stockpilePosTypes; } });
exports.default = stockpile_pos_sub_component_1.default;
